<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">修图剪辑</div>
      </div>
      <div class="haerd_right"></div>
    </div>

    <div class="module_box">
      <div class="health" @click.stop.prevent="goBeautiful">
        <div class="module_left">人物美颜</div>
        <div class="module_right_icon1 Beautiful1">
          <div class="module_right_icon2 Beautiful2">
            <div class="module_right_icon3 Beautiful3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goSlimming">
        <div class="module_left">瘦身美体</div>
        <div class="module_right_icon1 Slimming1">
          <div class="module_right_icon2 Slimming2">
            <div class="module_right_icon3 Slimming3"></div>
          </div>
        </div>
      </div>

      <div class="health" @click.stop.prevent="goPicture">
        <div class="module_left">快速拼图</div>
        <div class="module_right_icon1 Picture1">
          <div class="module_right_icon2 Picture2">
            <div class="module_right_icon3 Picture3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goAddText">
        <div class="module_left">添加文字</div>

        <div class="module_right_icon1 AddText1">
          <div class="module_right_icon2 AddText2">
            <div class="module_right_icon3 AddText3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goVideoClips">
        <div class="module_left">视频初剪</div>

        <div class="module_right_icon1 VideoClips1">
          <div class="module_right_icon2 VideoClips2">
            <div class="module_right_icon3 VideoClips3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goVideoEditing">
        <div class="module_left">视频精剪</div>

        <div class="module_right_icon1 VideoEditing1">
          <div class="module_right_icon2 VideoEditing2">
            <div class="module_right_icon3 VideoEditing3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goAIEditing">
        <div class="module_left">AI剪辑</div>

        <div class="module_right_icon1 AIEditing1">
          <div class="module_right_icon2 AIEditing2">
            <div class="module_right_icon3 AIEditing3"></div>
          </div>
        </div>
      </div>
      <div class="health" @click.stop.prevent="goToning">
        <div class="module_left">景物调色</div>

        <div class="module_right_icon1 Toning1">
          <div class="module_right_icon2 Toning2">
            <div class="module_right_icon3 Toning3"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="prompt">温馨提示：模拟体验，非真实操作。</div>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return {};
  },
  created() {},

  mounted() {},
  beforeDestroy() {},

  methods: {
    async goBack() {
      this.$router.replace({
        path: "/classification",
      });
    },
    async goBeautiful() {
      this.$router.push({
        path: "/edit/beautiful/index",
      });
    },
    async goVideoEditing() {
      this.$router.push({
        path: "/edit/videoEditing/index",
      });
    },
    async goAddText() {
      this.$router.push({
        path: "/edit/add/index",
      });
    },
    async goVideoClips() {
      this.$router.push({
        path: "/edit/videoClips/index",
      });
    },
    async goSlimming() {
      this.$router.push({
        path: "/edit/slimming/index",
      });
    },

    async goPicture() {
      this.$router.push({
        path: "/edit/picture/index",
      });
    },
    async goToning() {
      this.$router.push({
        path: "/edit/toning/index",
      });
    },
    async goAIEditing(){
      this.$router.push({
        path: "/edit/ai/index",
      });
    }
  },
};
</script>

<style scoped lang="less">
.newTop {
  top: 280px !important;
}
.newpadding {
  padding: 36px 40px 0 !important;
}
.newmargin {
  margin-top: 30px !important;
}
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  /* 紫红 */
  background: linear-gradient(
    180deg,
    rgb(216, 103, 255),
    rgb(227, 142, 255) 26.718%,
    rgb(255, 247, 235) 100%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}
.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url(@/assets/colorBg/backBtn.png) no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 44px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 45vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
  .haerd_right {
    position: absolute;
    right: 30px;
    top: 40px;
    z-index: 0;
    width: 378px;
    height: 260px;
    background: url(@/assets/edit/editIndex/editIndex_subscript.png) no-repeat
      center;
    background-size: 100% 100%;
    //   opacity: 0.7;
  }
}

.module_box {
  // width: 100%;
  // margin: 0 40px 0;
  position: absolute;
  top: 360px;
  max-height: 910px;
  overflow-y: auto;
  padding-right: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 0 30px;

  .health {
    position: relative;
    overflow: hidden;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 325px;
    padding: 27px 0;
    height: 95px;
    background: #ffffff;
    border-radius: 15px;
    margin-bottom: 30px;
    margin-right: 30px;
    .module_left {
      display: flex;
      // justify-content: center;
      margin-left: 20px;
      align-items: center;
      width: 150px;
      // height: 71px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: 500;
      font-size: 33px;
      letter-spacing: 2px;
      color: #333333;
      // margin-left: 20px;
      z-index: 99;
    }
    .module_right_icon1 {
      width: 250px;
      height: 253px;
      position: absolute;
      right: -25%;
      top: -50%;
      .module_right_icon2 {
        width: 130px;
        height: 117px;
        position: absolute;
        left: 22%;
        bottom: 4.5%;
        .module_right_icon3 {
          width: 70px;
          height: 70px;
          position: absolute;
          left: 13.5%;
          top: 23.5%;
        }
      }
    }

    .Beautiful1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Beautiful2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Beautiful3 {
      background: url("@/assets/edit/editIndex/beautiful.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Slimming1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Slimming2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Slimming3 {
      background: url("@/assets/edit/editIndex/slimming.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Picture1 {
      background: url("@/assets/colorBg/pink1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Picture2 {
      background: url("@/assets/colorBg/pink2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Picture3 {
      background: url("@/assets/edit/editIndex/picture.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AddText1 {
      background: url("@/assets/colorBg/green1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AddText2 {
      background: url("@/assets/colorBg/green2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AddText3 {
      background: url("@/assets/edit/editIndex/addText.png") no-repeat center;
      background-size: 100% 100%;
    }
    .VideoClips1 {
      background: url("@/assets/colorBg/red1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .VideoClips2 {
      background: url("@/assets/colorBg/red2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .VideoClips3 {
      background: url("@/assets/edit/editIndex/videoClips.png") no-repeat center;
      background-size: 100% 100%;
    }
    .VideoEditing1 {
      background: url("@/assets/colorBg/purple1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .VideoEditing2 {
      background: url("@/assets/colorBg/purple2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .VideoEditing3 {
      background: url("@/assets/edit/editIndex/videoEditing.png") no-repeat
        center;
      background-size: 100% 100%;
    }
    .AIEditing1 {
      background: url("@/assets/colorBg/orange1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AIEditing2 {
      background: url("@/assets/colorBg/orange2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .AIEditing3 {
      background: url("@/assets/edit/editIndex/AIEditing.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Toning1 {
      background: url("@/assets/colorBg/blue1.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Toning2 {
      background: url("@/assets/colorBg/blue2.png") no-repeat center;
      background-size: 100% 100%;
    }
    .Toning3 {
      background: url("@/assets/edit/editIndex/toning.png") no-repeat center;
      background-size: 100% 100%;
    }
  }
  .health:nth-child(2n) {
    margin-right: 0;
  }
}

.prompt {
  width: 100%;
  position: absolute;
  bottom: 2vh;
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
// }
</style>
